export const shareAssetsImages = {
    'not_overtime-blue-share-bg': 'https://res.126.net/cross/2022-fighting/not-overtime-blue-share-bg.png',
    'not_overtime-green-share-bg': 'https://res.126.net/cross/2022-fighting/not-overtime-green-share-bg.png',
    'not_overtime-red-share-bg': 'https://res.126.net/cross/2022-fighting/not-overtime-red-share-bg.png',
    'not_overtime-yellow-share-bg': 'https://res.126.net/cross/2022-fighting/not-overtime-yellow-share-bg.png',
    'overtime_small-yellow-share-bg': 'https://res.126.net/cross/2022-fighting/small-overtime-yellow-share-bg.png',
    'overtime_small-red-share-bg': 'https://res.126.net/cross/2022-fighting/small-overtime-red-share-bg.png',
    'overtime_small-blue-share-bg': 'https://res.126.net/cross/2022-fighting/small-overtime-blue-share-bg.png',
    'overtime_small-green-share-bg': 'https://res.126.net/cross/2022-fighting/small-overtime-green-share-bg.png',
    'overtime-yellow-share-bg': 'https://res.126.net/cross/2022-fighting/overtime-yellow-share-bg.png',
    'overtime-red-share-bg': 'https://res.126.net/cross/2022-fighting/overtime-red-share-bg.png',
    'overtime-blue-share-bg': 'https://res.126.net/cross/2022-fighting/overtime-blue-share-bg.png',
    'overtime-green-share-bg': 'https://res.126.net/cross/2022-fighting/overtime-green-share-bg.png',
    'share-icon': 'https://res.126.net/cross/2022-fighting/share-icon-2.png'
}

export const shareConfigOvertime = {
    type: "url",
    title: "网易邮箱大师 | 2022年终报告",
    desc: '2022我真的很拼，你呢？来测一测！',
    url: 'https://mail.163.com/hd/2022-fighting/?utm_source=share#/',
    thumbnail: shareAssetsImages["share-icon"],
}

export const shareConfigNotOvertime = {
    type: "url",
    title: "网易邮箱大师 | 2022年终报告",
    desc: '2022年我没加过班，你呢？来测一测！',
    url: 'https://mail.163.com/hd/2022-fighting/?utm_source=share#/',
    thumbnail: shareAssetsImages["share-icon"],
}


